module.exports = __webpack_public_path__ + "img/19.23f96716.jpg";